/**
 * 积分充值：open 域同路径 GET /asset/score-skus + POST /asset/score-order/confirm
 */
import billingApi from './billingApi'
import { getApiErrorMessage, unwrapOrderPayload } from './vipPayApi'

function assertApiOk(res) {
  if (res == null || typeof res !== 'object') return
  const c = res.code
  if (c === undefined || c === null) return
  const n = Number(c)
  if (n === 0 || n === 200) return
  const msg = res.message || res.msg || res.error || `接口 code=${c}`
  throw new Error(msg)
}

function unwrapScoreSkuList(res) {
  if (res == null) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.list)) return res.list
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && typeof d === 'object') {
    if (Array.isArray(d.list)) return d.list
    if (Array.isArray(d.data)) return d.data
  }
  return []
}

function priceYuanFromCents(cents) {
  const n = Number(cents)
  if (!Number.isFinite(n) || n <= 0) return 0
  if (n >= 100) return Math.round(n / 100)
  return Math.round(n)
}

export const DEFAULT_CREDIT_PACKS = [
  { id: 'default-490', skuId: null, points: 490, price: 7 },
  { id: 'default-1400', skuId: null, points: 1400, price: 20 },
  { id: 'default-2100', skuId: null, points: 2100, price: 30 },
  { id: 'default-3500', skuId: null, points: 3500, price: 50 },
  { id: 'default-7000', skuId: null, points: 7000, price: 100 },
  { id: 'default-14000', skuId: null, points: 14000, price: 200 }
]

export function mapScoreSkuToCreditPack(sku) {
  const points = Number(sku.score ?? sku.reward_scores ?? sku.points) || 0
  const price = priceYuanFromCents(sku.discount_money_price ?? sku.money_price)
  const oldPoints =
    sku.huaxian_score != null
      ? Number(sku.huaxian_score)
      : sku.line_score != null
        ? Number(sku.line_score)
        : null
  const bonus = sku.hottitle || sku.hot_title || sku.member_bonus || sku.bonus_tip
  return {
    id: `score-sku-${sku.id}`,
    skuId: sku.id,
    points,
    pointsOld: oldPoints && oldPoints > points ? oldPoints : null,
    price,
    memberBonus: bonus ? String(bonus) : null,
    featured: !!(sku.is_featured || sku.is_large || Number(sku.list_weight) >= 98)
  }
}

export async function fetchCreditRechargePacks(opts = {}) {
  const params = {
    page: opts.page ?? 1,
    limit: opts.limit ?? 50,
    ...(opts.extra || {})
  }
  const res = await billingApi.get('/asset/score-skus', { params })
  assertApiOk(res)
  const list = unwrapScoreSkuList(res)
  if (list.length) {
    return list
      .map(mapScoreSkuToCreditPack)
      .filter(p => p.points > 0)
      .sort((a, b) => (Number(a.price) || 0) - (Number(b.price) || 0))
  }
  return DEFAULT_CREDIT_PACKS.map(p => ({ ...p }))
}

export async function createScoreOrder(opts = {}) {
  const skuId = Number(opts.skuId)
  if (!Number.isFinite(skuId) || skuId <= 0) {
    throw new Error('请选择充值档位')
  }
  const res = await billingApi.post('/asset/score-order/confirm', {
    sku_id: skuId,
    payment_method: 'alipay',
    paymentMethod: 'alipay',
    pay_type: 'alipay'
  })
  assertApiOk(res)
  return unwrapOrderPayload(res)
}

export function mapUserToCreditsProfile(res) {
  const u =
    (res && res.data && res.data.user) ||
    (res && res.user) ||
    (res && res.data) ||
    {}
  const name = u.name || u.nickname || u.nicheng || '用户'
  const score = Number(u.score ?? u.credits ?? u.balance ?? 0) || 0
  return { name, score }
}

export async function fetchCreditsUserProfile() {
  const res = await billingApi.get('/user')
  return mapUserToCreditsProfile(res)
}

export { getApiErrorMessage }
